export default __webpack_public_path__ + "static/logo_butterfly-ff94b86ea9c439eb3b49e512a3b3bf3b.png";